import { ReactElement } from 'react';
import { Field, ErrorMessage } from 'formik';
import classNames from 'classnames';

interface CheckboxFieldProps {
  name: string;
  label?: string;
  required?: boolean;
  className?: string;
}

const CheckboxField = ({
  name,
  label,
  required = false,
  className = '',
}: CheckboxFieldProps): ReactElement => {
  return (
    <div className={classNames('flex items-start w-full mb-4', className)}>
      <Field name={name}>
        {({ field, meta }: any) => (
          <div className="flex items-center">
            <input
              {...field}
              id={name}
              type="checkbox"
              checked={field.value || false}
              className={classNames(
                'w-4 h-4 text-copper bg-gray-100 border-gray-300 rounded focus:ring-copper focus:ring-2',
                {
                  'border-red-500': meta.touched && meta.error,
                }
              )}
              required={required}
            />
            {label && (
              <label htmlFor={name} className="ml-2 text-sm font-medium">
                {label}
                {required && <span className="text-red-500 ml-1">*</span>}
              </label>
            )}
          </div>
        )}
      </Field>
      <ErrorMessage
        name={name}
        component="div"
        className="text-red-500 text-xs mt-1 ml-6"
      />
    </div>
  );
};

export default CheckboxField;